export default "__VITE_ASSET__ByRTDAt8__"